export var CostGranularity;
(function (CostGranularity) {
    CostGranularity["COST_GRANULARITY_HOURLY"] = "HOURLY";
    CostGranularity["COST_GRANULARITY_DAILY"] = "DAILY";
    CostGranularity["COST_GRANULARITY_MONTHLY"] = "MONTHLY";
    CostGranularity["COST_GRANULARITY_TOTAL"] = "TOTAL";
})(CostGranularity || (CostGranularity = {}));
